// extracted by mini-css-extract-plugin
module.exports = {"wrap":"rc","content":"sc","crumbsList":"tc","dropdownsWrap":"uc"};